"use strict";

var browserHeight = $(window).height(),
    browserWidth = $(window).width(),
    isDevice = false,
    isMobile = false;

if (browserWidth < 600) {
    isMobile = true;
}

$(document).ready(function () {
    setTextInfoHeights();
});

var newtimestamp = Date.now();

function logstuff(message) {
    var temptimestamp = Date.now() - newtimestamp;
    console.log(temptimestamp + "(" + temptimestamp / 1000 + "): " + message);
}

function setTextInfoHeights() {
    logstuff('setTextInfoHeights');
    $('.victory').each(function (index) {
        var temp = Math.round($(this).find('.info').outerHeight());
        $(this).attr('data-height', temp);
        $(this).find('.info').css('visibility', 'hidden');
        $(this).find('.info').css('height', '0px');
    });
}

$('.victory').on('click', function () {

    if ($(this).hasClass('visible')) {

        var tlOpen = new TimelineMax();

        tlOpen.fromTo($(this).find('.info'), 0.5, {
            opacity: 1
        }, {
            opacity: 0
        });

        tlOpen.fromTo($(this).find('.info'), 0.5, {
            css: { height: $(this).attr("data-height") }

        }, {
            css: { height: "0" }
        }, "-=0.3");

        tlOpen.fromTo($(this).find('.more'), 0.3, {
            opacity: 0
        }, {
            opacity: 1
        }, "-=0.1");

        $(this).removeClass('visible');
    } else {

        var anyVisible = false;
        var _tlOpen = new TimelineMax();

        $('.victory').each(function (index) {
            if ($(this).hasClass('visible')) {
                anyVisible = true;

                _tlOpen.fromTo($(this).find('.info'), 0.3, {
                    opacity: 1
                }, {
                    opacity: 0
                });

                _tlOpen.fromTo($(this).find('.info'), 0.3, {
                    css: { height: $(this).attr("data-height") }

                }, {
                    css: { height: "0" }
                }, "-=0.1");

                _tlOpen.fromTo($(this).find('.more'), 0.3, {
                    opacity: 0
                }, {
                    opacity: 1
                }, "-=0.1");

                $(this).removeClass('visible');
            }
        });

        _tlOpen.fromTo($(this).find('.info'), 0.5, {
            css: { height: "0" }
        }, {
            css: { height: $(this).attr("data-height") }
        });

        _tlOpen.fromTo($(this).find('.more'), 0.3, {
            opacity: 1
        }, {
            opacity: 0
        }, "-=0.1");

        _tlOpen.fromTo($(this).find('.info'), 0.5, {
            opacity: 0
        }, {
            opacity: 1
        }, "-=0.3");

        $(this).find('.info').css('visibility', 'visible');
        $(this).addClass('visible');
    }
});

var tl = new TimelineMax();

tl.fromTo($('.article-content'), .8, {
    y: 30,
    opacity: 0
}, {
    y: 0,
    opacity: 1,
    ease: Power1.easeOut
});

tl.add(animateMarkerLine);

tl.staggerFromTo($('.victory'), 1, {
    y: 20,
    opacity: 0
}, {
    y: 0,
    opacity: 1,
    ease: Power4.easeOut,
    onComplete: function onComplete() {
        $($(this)[0].target.children[0].children[0].children[0].children).addClass('animate-it');
        $($(this)[0].target.children[0].children[0].children[0].children).attr('stroke-dashoffset', '0');
    }
}, 0.8, "-=0.1");

function animateMarkerLine() {
    logstuff("animateMarkerLine");
    $('#markerline path').addClass('animate-it');
    $('#markerline path').attr('stroke-dashoffset', '0');
}